




























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import TabModel from "@/store/entities/tab-service";
@Component
export default class TabService extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  keywordLeft: string = "";
  keywordRight: string = "";
  model: TabModel[] = [];
  data: TabModel[] = [];
  allLeft: boolean = false;
  allRight: boolean = false;
  @Prop({ type: String, default: "" }) moduleName: String;
  @Prop({ type: Boolean, default: false }) isUpdate: boolean;

  get dataLeft() {
    let result = this.data.filter(
      p =>
        !this.keywordLeft ||
        p.name.toUpperCase().indexOf(this.keywordLeft.toUpperCase()) >= 0
    );
    return result;
  }

  get dataRight() {
    let result = this.model.filter(
      p =>
        !this.keywordRight ||
        p.name.toUpperCase().indexOf(this.keywordRight.toUpperCase()) >= 0
    );
    return result;
  }

  loadServices() {
    const editClient = { ...this.$store.state.client.editClient };
    const client = { ...this.$store.state.client };
    const selected = (editClient[`${this.moduleName}`] || []).map(e => e.id);
    this.data = (client[`${this.moduleName}`] || []).filter(
      p => !selected.includes(p.id)
    );
    this.model = (client[`${this.moduleName}`] || []).filter(p =>
      selected.includes(p.id)
    );
  }

  mounted() {
    this.$store.watch(
      (state, getters) => state.client[`${this.moduleName}`],
      (newValue, oldValue) => {
        if (newValue && newValue.length > 0) {
          this.loadServices();
        }
      }
    );
  }

  destroyed() {
    this.$store.commit("client/updateService", {
      moduleName: this.moduleName,
      data: []
    });
  }

  moveLeft() {
    const selected = this.model.filter(e => e.isSelected);
    selected.forEach(e => {
      const isExist = this.data.find(p => p.id == e.id);
      const index = this.model.findIndex(p => p.id == e.id);
      if (!isExist) {
        e.isSelected = false;
        this.data.push(e);
        this.model.splice(index, 1);
      }
    });
    this.$store.commit("client/updateService", {
      moduleName: this.moduleName,
      data: this.model
    });
    this.refreshForm();
    this.allRight = false;
  }

  moveRight() {
    const selected = this.data.filter(e => e.isSelected);
    selected.forEach(e => {
      const isExist = this.model.find(p => p.id == e.id);
      const index = this.data.findIndex(p => p.id == e.id);
      if (!isExist) {
        e.isSelected = false;
        this.model.push(e);
        this.data.splice(index, 1);
      }
    });
    this.$store.commit("client/updateService", {
      moduleName: this.moduleName,
      data: this.model
    });
    this.refreshForm();
    this.allLeft = false;
  }

  selectItemLeft(item, event) {
    item.isSelected = event;
    const count = this.data.filter(e => e.isSelected).length;
    this.allLeft = count == this.data.length;
  }

  selectItemRight(item, event) {
    item.isSelected = event;
    const count = this.model.filter(e => e.isSelected).length;
    this.allRight = count == this.model.length;
  }

  selectLeft(event) {
    this.data.forEach(e => {
      e.isSelected = event;
    });
  }

  selectRight(event) {
    this.model.forEach(e => {
      e.isSelected = event;
    });
  }

  refreshForm() {
    const rightCount = this.model.filter(e => e.isSelected).length;
    this.allRight = rightCount == this.model.length && rightCount != 0;
    const leftCount = this.data.filter(e => e.isSelected).length;
    this.allLeft = leftCount == this.data.length && leftCount != 0;
  }
}
